import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    upgradePlan: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Accessibility label for upgrade modal button (screen readers only) */
            upgradePlan: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UpgradeModalButton.upgradePlan?c=l5z7ihsnr6a2", defaultMessage: "Upgrade plan" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
